const enum MAIN_GOAL {
  LOSE_WEIGHT = "Lose Weight",
  GAIN_MUSCLE = "Gain Muscle",
  LEARN_TO_DANCE = "Learn to Dance",
}

export default MAIN_GOAL;
